import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import useTableDisplayFields from "./TableDisplayFields.hooks";
import { useTranslation } from "../../../localization/useTranslation";
import { TableFields } from "./TableFields.types";
import { DisplayIcon } from "../../icons";
import { listPageToolbarChangedDot, listPageToolbarIconButton, listPageToolbarIconButtonSize } from "@common/components/listPageToolbar/ListPageToolbar.styles";
import { Badge, Box } from "@mui/material";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider";
import PlanDialogButtonWrapper from "../../../plan/planDialogWrapper/planDialogWrapper.tsx";
import { FieldGroupingType } from "../filterPopover/FilterPopover.types.ts";

export interface TableDisplayFieldsProps {
    options: Array<TableFields>;
    onSave: (selectedColumns: Array<string>) => void;
    selectedFields: Array<string>;
    hasDisplayChanged: boolean;
    isCustomView: boolean;
    /** The columns of the view the list is showing, which Reset goes back to. Empty when the view stores none. */
    savedViewFields: Array<string> | undefined;
    groupingOrder: Array<FieldGroupingType>;
    renderSelectedField?: (fieldId: string, fieldName: string) => JSX.Element | undefined;
}

function TableDisplayFields(props: TableDisplayFieldsProps) {
    const { translateString } = useTranslation();
    const { togglePane } = useTableDisplayFields(props);
    const { platformFeatures } = usePlanContext();

    const featureLocked = !platformFeatures.canSaveTableConfiguration;
    return (
        <PlanDialogButtonWrapper enabled={featureLocked} text={translateString("upgradeToCustomList")}>
            <Box sx={listPageToolbarIconButton}>
                <DotLegalButton
                    btnLength={listPageToolbarIconButtonSize}
                    buttonType={"secondary"}
                    disabled={featureLocked}
                    onClick={togglePane}
                    toolTip={
                        featureLocked
                            ? translateString("upgradeToCustomList")
                            : props.hasDisplayChanged
                              ? translateString("displayChangedTooltip")
                              : translateString("editColumnView")
                    }
                >
                    <Badge sx={listPageToolbarChangedDot} variant="dot" invisible={!props.hasDisplayChanged}>
                        {DisplayIcon}
                    </Badge>
                </DotLegalButton>
            </Box>
        </PlanDialogButtonWrapper>
    );
}

export default TableDisplayFields;
